<template lang="pug">
v-container(ma-0 pa-0 fluid style="margin-top: 100px !important; margin-bottom: 150px !important;")
  v-layout.onlineEducation-and-video(text-xs-left='', wrap='' align-item-center justify-center)
    v-flex.section-onlineEducation-video(xs12 offset-xs0 offset-md0 md6)
      v-layout(align-center justify-center fill-height)
        iframe(:src='video_url', 
              frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', 
              allowfullscreen='')
    v-flex.section-onlineEducation(xs10 offset-xs0 offset-md1 md3)
      h1.title-all A+選民的急速領域<br>
      br
      span.content-all(v-html="onlineText")

</template>

<script>
export default {
  data: () => ({
    video_url: "https://www.youtube.com/embed/yyyg4DJ4uBA",
    onlineText: `
    每個18歲的你，都有不一樣的想法和故事。<br><br>

    什麼是公投？什麼是選舉？我可以投嗎？<br><br>

    當你要蓋下「同意」、「不同意」之前，<br>
    可以從哪些地方取得哪些相關資訊？<br><br>

    但怎麼樣的18歲，能夠是一個成熟的公民？<br><br>

    你一定要知道：<br>
    <a href="https://hackmd.io/cOSKeo_YQzeJ9hKyN-kncg?view" target="_blank">走進投票所之前非做不可的事⋯⋯</a><br><br>

    <a href="https://hackmd.io/c/B1UUiT2s4/%2Fs%2FSJNrCDA6E" target="_blank">選民教育 Online</a>，18歲之前就能漂亮甩尾！`
  }),
  mounted() {}
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 500px;
}
.section-onlineEducation {
  @media screen and (max-width: 959px) {
    margin-top: 50px;
  }
}
</style>
